export default {
  // 'example': () => import('@/modules/example'),
  'double-eleven': () => import('@/modules/double-eleven'),
  'double-eleven2019': () => import('@/modules/double-eleven2019'),
  'grab-red-envelopes': () => import('@/modules/grab-red-envelopes'),
  'lucky-wheel': () => import('@/modules/lucky-wheel'),
  'get-stars': () => import('@/modules/get-stars'),
  'group-buying': () => import('@/modules/group-buying'),
  'lucky-koi': () => import('@/modules/lucky-koi'),
  'national-day': () => import('@/modules/national-day'),
  'reservation': () => import('@/modules/reservation'),
  'lucky-shake': () => import('@/modules/lucky-shake'),
  'lucky-box': () => import('@/modules/lucky-box'),
  'operation-easter-egg': () => import('@/modules/operation-easter-egg'),
  'custom-gift': () => import('@/modules/custom-gift'),
  'bargain-action': () => import('@/modules/bargain-action'),
  'color-run': () => import('@/modules/color-run'),
  'lit': () => import('@/modules/lit'),
  'mothersday': () => import('@/modules/mothersday'),
  'love-goddess': () => import('@/modules/love-goddess'),
  'day-day-happy': () => import('@/modules/day-day-happy'),
  'in-tanabata': () => import('@/modules/in-tanabata'),
}